<script>
    import {onMount} from "svelte";
    import Assessment from '../../Models/assessmentModel';
    import Loader from '../Loader.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';

    import {sortBy} from 'lodash-es';

    import {forms} from '../../lib/forms'
    import {assign} from 'lodash-es';

    import {assessment_type_categories} from '../../lib/assessment_type_categories';
    import SortableTable from '../SortableTable.svelte';

    import RecommendationModel from '../../Models/recommendationModel';

    export let assessment_model;
    let assessment;

    let recommendations = [];
    let duplicates = new Set();

    function loadRecommendations(assessment_data) {
        if (!assessment_data) return;
        recommendations = [];
        for (let category_recommendations of Object.values(assessment_data.recommendations)) {
            recommendations = [...recommendations, ...category_recommendations];
        }

        let sorted_recommendations = sortBy(recommendations, ['finding', 'recommendation']);

        duplicates = new Set();
        let last_recommendation;
        for (let recommendation of sorted_recommendations) {
            if (last_recommendation && last_recommendation.finding == recommendation.finding && last_recommendation.recommendation == recommendation.recommendation) {
                duplicates.add(recommendation);
            }

            last_recommendation = recommendation;
        }
    }

    $: loadRecommendations($assessment);

    function editRecommendation(recommendation) {
        addFormModal({
            fields: forms['recommendation'],
            data: recommendation
        }).then(formData => {
            assessment_model.updateRecommendation(formData).then(() => notifier.success("Recommendation Saved"));
        }).catch(() => null)
    }

    function deleteRecommendation(recommendation) {
        confirm("Are you sure you want to delete this recommendation?").then(
            () => {
                assessment_model.deleteRecommendation(recommendation)
            }
        ).catch(() => null)
    }

    function removeDuplicates() {

        for (let dup of duplicates) {
            assessment_model.deleteRecommendation(dup);
        }
    }

    async function saveNewRecommendation(recommendation) {
        // make a copy
        let recommendation_template = JSON.parse(JSON.stringify(recommendation));

        delete recommendation_template._id;
        delete recommendation_template._rev;
        delete recommendation_template.recommendation_id;
        delete recommendation_template.template_id;

        let new_template = await RecommendationModel.createStockRecommendation(recommendation_template);
        recommendation.template_id = new_template.id;
        assessment_model.updateRecommendation(recommendation);

        notifier.success("Template Created");
    }

    async function saveRecommendationTemplate(recommendation) {
        try {
            await confirm("Are you sure you want to update this recommendation for all future reports?");
        } catch (e) {
            return;
        }

        // make a copy
        let recommendation_template = JSON.parse(JSON.stringify(recommendation));

        delete recommendation_template._id;
        delete recommendation_template._rev;
        delete recommendation_template.recommendation_id;
        delete recommendation_template.template_id;

        if (recommendation.template_id) {
            try {
                var stock_recommendation = await RecommendationModel.getStockRecommendation(recommendation.template_id)
            } catch (e) {
                notifier.warning("Recommendation Template does not exist")

                delete recommendation.template_id;
                assessment_model.updateRecommendation(recommendation);

                return
            }
            assign(stock_recommendation, recommendation_template);
            await RecommendationModel.saveStockRecommendation(stock_recommendation);
        } else {
            let new_template = await RecommendationModel.createStockRecommendation(recommendation_template);
            recommendation.template_id = new_template.id;
            assessment_model.updateRecommendation(recommendation);
        }

        notifier.success("Template Saved");
    }

    function toggleReport(recommendation) {
        recommendation.report = !recommendation.report
        assessment_model.updateRecommendation(recommendation);
    }

    onMount(() => {
        assessment = assessment_model.store;
    })
</script>

<Loader loading={!$assessment}>
    <div class="column">
        <SortableTable sortFields={assessment_type_categories[$assessment.assessment_type_data.assessment_type_category || "Risk Assessment"].tables['recommendations']} tableData={recommendations} tableClass="NISTTable">
            <div slot="filterActions">
                {#if duplicates.size}
                    <div class="button" on:click={() => removeDuplicates()}>Remove {duplicates.size} duplicate finding{duplicates.size > 1 ? "s" : ""}</div>
                {/if}
            </div>
            <div slot="rowActions" let:row={recommendation}>
                <div class="tags">
                    {#if duplicates.has(recommendation)}
                        <div class="tag is-danger">Duplicate</div>
                    {/if}
                </div>
                <div class="buttons">
                    <div class="button is-primary" on:click={() => editRecommendation(recommendation)}>Edit</div>
                    <div class="button is-danger" on:click={() => deleteRecommendation(recommendation)}>Delete</div>
                    <div class="button is-link" on:click={() => saveRecommendationTemplate(recommendation)}>
                        {#if recommendation.template_id}
                            Update Template
                        {:else}
                            Save as Template
                        {/if}
                    </div>
                    {#if recommendation.template_id}
                        <div class="button is-info" on:click={() => saveNewRecommendation(recommendation)}>
                            Save as New Template
                        </div>
                    {/if}
                    <div class="button is-success" class:is-light={!recommendation.report} on:click={() => toggleReport(recommendation)}>
                        Include in Executive Summary
                    </div>

                </div>
            </div>
        </SortableTable>
    </div>
</Loader>
